import {message} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {FaFacebookF} from 'react-icons/fa'
import {RiRepeat2Fill, RiShareForwardFill,} from 'react-icons/ri'
import {NullAsDefault, renderSelf} from 'views/Shared'
import DrawMenu from '../drawer/DrawMenu'
import Count from './Count'
import FeedContext from './FeedContext'
import {PiLinkSimpleBold, PiShareFat} from "react-icons/pi";
import {FaXTwitter} from "react-icons/fa6";
import {renderIfElse} from "../../views/Shared";
import copyToClipboard from "copy-to-clipboard";
import {MdOpenInNew} from "react-icons/md";
import {APP_NAME} from "../../envs/_current/config";
import Ahref from "../Ahref";

export const Share = ({
                          url,
                          context = FeedContext,
                          withProps = renderSelf,
                          title,
                          className,
                          component,
                          actions = [
                              "share_on_channel",
                              "copy_link",
                              "share_via",
                              "share_via_others"
                          ]
                      }) => {
    const ctx = useContext(context)
    const {item, handleClick = NullAsDefault} = withProps(ctx) ?? {}
    const handleMenuClick = (e) => {
        handleClick(e.key)
    }
    const translate = useTranslate()

    const createFacebookUrl = (url) =>
        `https://www.facebook.com/sharer/sharer.php?u=${url}`
    const createTwitterUrl = (url) =>
        `https://twitter.com/intent/tweet?url=${url}`

    const menuItems = [];

// Mở tab mới
    if (actions.includes("open_link_in_new_tab")) {
        menuItems.push({
            key: "open_link_in_new_tab",
            icon: <MdOpenInNew className="text-color-300" />,
            label: (
                <Ahref
                    target="_blank"
                    rel="noopener noreferrer"
                    href={url}
                    className="hover:text-primary no-underline"
                >
                    {translate("open link in new tab")}
                </Ahref>
            ),
        });
    }

// Share trên channel
    if (actions.includes("share_on_channel")) {
        menuItems.push({
            key: "share_on_channel",
            icon: <RiRepeat2Fill className="text-color-300" />,
            label: (
                <span className="hover:text-primary">
        {translate("share on my channel")}
      </span>
            ),
        });
    }

// Copy link
    if (actions.includes("copy_link")) {
        menuItems.push({
            key: "copy_link",
            icon: <PiLinkSimpleBold className="text-color-300" />,
            label: (
                <span className="hover:text-primary">
        {translate("copy link")}
      </span>
            ),
        });
    }

// Share qua Facebook / Twitter
    if (actions.includes("share_via")) {
        menuItems.push(
            {
                key: "share_viaFacebook",
                icon: <FaFacebookF className="text-color-300" />,
                label: (
                    <Ahref
                        className="no-underline text-color-300 hover:text-primary"
                        href={createFacebookUrl(url)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {`${translate("share via")} Facebook`}
                    </Ahref>
                ),
            },
            {
                key: "share_viaX",
                icon: <FaXTwitter className="text-color-300" />,
                label: (
                    <Ahref
                        className="no-underline text-color-300 hover:text-primary"
                        href={createTwitterUrl(url)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {`${translate("share via")} Twitter`}
                    </Ahref>
                ),
            }
        );
    }

// Share qua thiết bị khác
    if (actions.includes("share_via_others")) {
        menuItems.push({
            key: "share_via_others",
            icon: <RiShareForwardFill className="text-color-300" />,
            label: (
                <span className="hover:text-primary">
                    {translate("share")}
                </span>
            ),
        });
    }

    return (
        <DrawMenu
            menuPlacement="bottomLeft"
            menu={{
                items: menuItems,
                onClick: (e) => {
                    switch (e.key) {
                        case "copy_link":
                            copyToClipboard(url);
                            message.success(translate("copied"));
                            break;

                        case "share_via_others":
                            if (navigator.share) {
                                navigator
                                    .share({
                                        title: title || APP_NAME,
                                        url: url,
                                    })
                                    .then(() => console.log("Successful share"))
                                    .catch((error) => console.log("Error sharing", error));
                            } else if (window.plugins?.socialsharing) {
                                window.plugins.socialsharing.share(
                                    title || APP_NAME,
                                    title || APP_NAME,
                                    null,
                                    url
                                );
                            } else {
                                alert(translate("sharing is not supported on this device"));
                            }
                            break;

                        // Bỏ qua các mục tự xử lý bằng link hoặc không cần click
                        case "open_link_in_new_tab":
                        case "share_viaFacebook":
                        case "share_viaX":
                            break;

                        default:
                            handleMenuClick(e);
                    }
                },
            }}
            component={
                renderIfElse(
                    component,
                    component,
                    <Count color="text-primary" className={className} component={!title && PiShareFat}>
                        {title}
                    </Count>
                )
            }>
        </DrawMenu>
    )
}
